<template>
  <select v-model="selected">
    <option></option>
    <option
      v-for="nationality of nationalities"
      :key="nationality.code"
      :value="nationality">
        {{ nationality.name }}
    </option>
  </select>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Nationality } from '@/store/master/types'

@Component
export default class NationalityInput extends Vue {
  @Prop() value?: Nationality

  created() {
    this.$store.dispatch('fetchMasterNationalities');
  }

  private get nationalities(): Nationality[] {
    return this.$store.state.master.nationalities
  }

  private get selected(): Nationality|null {
    return this.value || null
  }

  private set selected(nationality: Nationality|null) {
    this.$emit('input', nationality)
  }
}
</script>

<style scoped>
  select{
    padding: 5px;
    border: 1px solid #AAAFB6;
    border-radius: 30px;
    width: 100%;
  }
</style>
